// simply redirect to /sync/ route
export default {
  path: "/library/:resourceSlug/:cohortId(\\d+)/:section/publish/",
  onEnter: (nextState, replaceState) =>
    replaceState({
      ...nextState,
      pathname: `/library/${nextState.match.params.resourceSlug}/${nextState.match.params.cohortId}/${nextState.match.params.section}/sync/`
    })
}
